import * as Sentry from '@sentry/browser'

export function setSentryUserContext (user) {
  if (process.env.VUE_APP_SENTRY_DSN) {
    Sentry.getCurrentScope().setUser({ id: user.pk, email: user.email })
  }
}

export function clearSentryUserContext () {
  if (process.env.VUE_APP_SENTRY_DSN) {
    Sentry.getCurrentScope().setUser(null)
  }
}
